export default __webpack_public_path__ + "87b0be2f4311565d06f2441cd226c57e.png";